import { JetView } from 'webix-jet';
import { countries, devConfig, profile } from 'config/config';

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span>ID"), // ID label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for ID input
                        },
                        {
                            view: 'text',
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder for User ID input
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'), // Country selection label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for country selection
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for country options
                                        );
                                    },
                                    data: countries, // Data source for country options
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    height: document.body.offsetWidth < 500 ? 100 : 0, // Responsive height
                    cols: [
                        {
                            view: 'radio',
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Type selection label
                            labelPosition: 'top',
                            value: 0, // Default value
                            options: [
                                { id: 0, value: _('Detallado') }, // Detailed option
                                { id: 1, value: _('Totales') }, // Total option
                            ],
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 300 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button label
                            width: screen == 'small' ? 0 : 100, // Responsive width
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values
                                $$('Type').setValue(0); // Reset Type selection
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button label
                            hotkey: 'enter', // Hotkey for button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Responsive width
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('balanceAdjustments:filter', [filterdata]); // Trigger filter event
                                $$('b5').collapse(); // Collapse filter section
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section2], // Main layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element for small screens
                $$('grav2').hide(); // Hide element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
